var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-6 flex flex-col"},[_c('pending-request',{attrs:{"users":_vm.users}}),_vm._v(" "),_c('transfer-requests',{attrs:{"users":_vm.users}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }